import {useRef, useEffect, useMemo, useCallback} from '@wordpress/element';
import {useApiRequests} from "../../../hooks";
import {useCreditCardContext} from "./use-credit-card-context";

export const useCardOptions = (
    {
        data,
        billing,
        shippingData,
        needsSetupToken,
        shouldSavePayment
    }) => {

    const currentData = useRef({
        billing,
        shipping: shippingData,
        shouldSavePayment
    });

    useEffect(() => {
        currentData.current = {
            billing,
            shipping: shippingData,
            shouldSavePayment
        }
    }, [
        billing,
        shippingData,
        shouldSavePayment
    ])

    const {
        createOrder,
        createPaymentToken,
        createVaultSetupToken
    } = useApiRequests({
        paymentMethod: 'ppcp_card'
    });

    const {
        events,
        addPaymentMethodData
    } = useCreditCardContext();

    const options = useMemo(() => {
        const options = {
            fundingSource: 'card',
            style: data.styles,
            inputEvents: events,
            onApprove: (data) => {
                if (data.vaultSetupToken) {
                    return createPaymentToken(data.vaultSetupToken).then((response) => {
                        addPaymentMethodData({
                            orderId: data.orderID || '',
                            paymentTokenId: response.id
                        });
                    });
                } else {
                    addPaymentMethodData({
                        orderId: data.orderID || '',
                        paymentTokenId: ''
                    });
                }
            },
            createOrder: (...args) => {
                return createOrder(currentData.current);
            },
            ...(needsSetupToken && {
                createOrder: null,
                createVaultSetupToken: (...args) => {
                    return createVaultSetupToken(...args);
                }
            }),
            onError: error => {

            }
        }

        return options;
    }, [
        events,
        needsSetupToken,
        addPaymentMethodData
    ]);

    return {
        options
    };
}